import React, { useState, useEffect, useRef } from 'react';
import { Button, Container, Row, Col, Modal, ProgressBar } from "react-bootstrap";
import { Switch, Route, useHistory, useRouteMatch, useLocation, useParams } from 'react-router-dom';
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { userActions, resourceActions, templateActions } from '../../actions';
import { useTranslation } from 'react-i18next';
import PageTitle from "../../components/common/PageTitle";
import AuthImage from "../../components/common/AuthImage";
import { useFormik } from 'formik';

const AddResource = params => {
    const { lite, types, uploadBtn, tempId } = params;
    const history = useHistory();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    // const user = useSelector(state => state.authentication.user);
    const loading = useSelector(state => state.template.status);
    const uploading = useSelector(state => state.resource.uploading);
    const uploadingIndex = useSelector(state => state.resource.multiUploadIndex);
    const uploadingTotal = useSelector(state => state.resource.multiUploadTotal);
    const uploadProgress = useSelector(state => state.resource.uploadProgress);
    const uploadResult = useSelector(state => state.resource.uploadResult);
    const templateId = useSelector(state => state.template.templateId);
    const group = useSelector(state => state.authentication.user.group);
    const [sendUpdate, setSendUpdate] = useState(0)
    const [multiUpload, setMultiUpload] = useState({ status: '', current: 0, total: 0 })
    const [resourceType, setResourceType] = useState('');
    const [resourceFileType, setResourceFileType] = useState('');
    const [selectedFile, setSelectedFile] = useState('');
    const [fileError, setFileError] = useState('');
    const [batchName, setBatchName] = useState('');
    const [displayName, setDisplayName] = useState('');
    const [createComplete, setCreateComplete] = useState();
    const [frameName, setFrameName] = useState();
    const fileInputRef = useRef();
    const uploadFormRef = useRef();
    const tagsFaRef = useRef();
    const uploadBtnRef = useRef();
    const frameNameRef = useRef();
    const maskPathRef = useRef();
    const frameWidthRef = useRef();
    const frameHeightRef = useRef();
    let nameTimeout = null;
    const resourcesTypes = [
        { name: 'Image', accept: 'image/jpeg,image/png,image/svg+xml,image/gif' },
        { name: 'Shape', accept: 'image/svg+xml' },
        { name: 'Vector', accept: 'image/svg+xml' },
        { name: 'Video', accept: 'video/mp4,video/quicktime' },
        { name: 'Frame', accept: 'image/svg+xml', disable: true },
        { name: 'Grid', disable: true },
        { name: 'Line', disable: true },
    ]

    const resourceTypes = [
        { name: 'Image/Vector/Video', type: 'file', accept: 'image/jpeg,image/png,image/svg+xml,image/gif,image/svg+xml,video/mp4,video/quicktime' },
        { name: 'Frame', type: 'frame', accept: 'image/svg+xml', disable: false },
        // { name: 'Grid', type: 'grid', disable: true },
        // { name: 'Line', type: 'line', disable: true },
    ]

    const uploadTypes = ['Image', 'Shape', 'Vector', 'Video'];

    useEffect(() => {
        if (uploadBtn) {
            const btnHolder = document.getElementById(uploadBtn)
            btnHolder && btnHolder.append(uploadBtnRef.current)
            uploadBtnRef.current.style.opacity = 1;
        }
    }, [uploadBtn, uploadBtnRef])

    useEffect(() => {
        if (createComplete !== 1 || (uploadResult !== 'success' && uploadResult !== 'failed')) return;

        if (!Array.isArray(selectedFile)) {
            if (uploadResult === 'success') setCreateComplete(2);
            return;
        }

        if (uploadingIndex + 1 <= uploadingTotal) {
            const preview = document.getElementById(`preview_${uploadingIndex}`)
            preview && preview.classList.remove('showLoader')
            if (uploadResult === 'success') {
                preview && preview.classList.add('success')
                if (uploadingIndex + 1 === uploadingTotal) {
                    setCreateComplete(2);
                }
            } else {
                preview && preview.classList.add('danger')
            }
            if (uploadingIndex + 1 < (uploadingTotal)) {
                uploadFormHandleMulti(uploadingIndex + 1)
            }
        }
    }, [createComplete, uploadResult, uploadingIndex, uploadingTotal, selectedFile])

    useEffect(() => {
        if (uploadingIndex + 1 === uploadingTotal) {
            setTimeout(() => {
                if (uploadResult === 'success') resetForm();
            }, 500);
        }
    }, [uploadResult, uploadingIndex, uploadingTotal])

    const resetForm = () => {
        uploadFormRef.current.reset();
        setResourceType('')
        setResourceFileType('')
        setSelectedFile('')
        setFileError('')
        setBatchName('')
        setDisplayName('')
    }

    useEffect(() => () => {
        const files = Array.isArray(selectedFile) ? selectedFile : [selectedFile];
        files.forEach(file => {
            if (_.get(file, 'preview', '').startsWith('blob:')) {
                URL.revokeObjectURL(file.preview);
            }
        });
    }, [selectedFile]);

    useEffect(() => {
        // checkFrameName()
        if (frameName) {
            maskPathHandler()
        }
    }, [frameName])

    const svgMask = (element) => {
        const path = _.get(element, 'path', element)
        const text = (`
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${frameWidthRef.current.value} ${frameHeightRef.current.value}">
                <mask id="mask" fill="#fff">
                    ${path}
                </mask>
                <g id="preview" fill="#5f5">
                    ${path}
                    <image href="/assets/images/noPic.jpg" height="100%" width="100%" preserveAspectRatio="xMidYMid slice" mask="url(#mask)" />
                </g>
            </svg>
        `)
        var node = document.createElement('svg')
        var parser = new DOMParser();
        var doc = parser.parseFromString(text, "image/svg+xml");
        // node.appendChild(document.createTextNode(text));
        node.innerHTML = text;
        // first an doctype
        var svgDocType = document.implementation.createDocumentType('svg', "-//W3C//DTD SVG 1.1//EN", "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd");
        // then a new SVG Document
        var svgDoc = document.implementation.createDocument('http://www.w3.org/2000/svg', 'svg', svgDocType);
        // set its documentElement to our root svg node (well a clone of it)
        svgDoc.replaceChild(node.cloneNode(true), svgDoc.documentElement);
        // serialize the document
        var svgData = (new XMLSerializer()).serializeToString(doc);
        setResourceFileType('Frame')
        return svgData;
    }

    const uploadFormHandle = () => {
        uploadFormRef.current.reportValidity();
        if (!uploadFormRef.current.checkValidity()) return;
        if (_.has(tagsFaRef, 'current.value')) {
            tagsFaRef.current.value = tagsFaRef.current.value.replace(/،/g, ",")
        }
        const formData = new FormData(uploadFormRef.current);

        setTimeout(() => {
            const files = formData.get('files');
            const fileType = (files.type || '').split('/')[1] || (files.name.split('.').pop() || '').toLowerCase();
            const params = {
                type: fileType === 'gif' ? 'Vector' : (resourceFileType ? resourceFileType : selectedFile.type),
            };

            setCreateComplete(1);
            dispatch(resourceActions.upload(formData, params));
        });
    }

    const uploadFormHandleMulti = (uploadIndex) => {
        if (uploadIndex === 0 && !uploadFormRef.current.reportValidity()) return;
        if (!selectedFile.every((file) => file.type === selectedFile[0].type)) {
            alert('All file must have same type.')
            return;
        }
        let multiResourcePreview = document.querySelectorAll('.multiResourcePreview');
        [...multiResourcePreview].map(target => {
            target.classList.add('showLoader');
        })
        if (_.has(tagsFaRef, 'current.value')) {
            tagsFaRef.current.value = tagsFaRef.current.value.replace(/،/g, ",")
        }
        const formData = new FormData(uploadFormRef.current);
        formData.delete("files");
        formData.append("files", selectedFile[uploadIndex].file);

        setTimeout(() => {
            const files = selectedFile[uploadIndex].file;
            const fileType = (files.type || '').split('/')[1] || (files.name.split('.').pop() || '').toLowerCase();
            const uploadParams = {
                fileIndex: uploadIndex,
                total: selectedFile.length,
                type: fileType === 'gif' ? 'Vector' : (resourceFileType ? resourceFileType : selectedFile[uploadIndex].type),
            };

            if (uploadIndex === 0) {
                setCreateComplete(1);
            }
            dispatch(resourceActions.upload(formData, uploadParams));
        });
    }

    const resourceTypeChangeHandler = (e) => {
        setResourceType(e.currentTarget.value)
        setSelectedFile('')
        setResourceFileType('')
        setFileError('')
        setBatchName('')
        setDisplayName('')
        if (fileInputRef.current) fileInputRef.current.value = '';
    }

    function svgToBlob(svgData) {
        var blob = new Blob([svgData], {
            type: 'image/svg+xml',
            name: 'test.svg'
        });
        return blob;
    }

    function createFileList(a) {
        a = [].slice.call(Array.isArray(a) ? a : arguments)
        for (var c, b = c = a.length, d = !0; b-- && d;) d = a[b] instanceof File
        if (!d) throw new TypeError('expected argument to FileList is File or array of File objects')
        for (b = (new ClipboardEvent('')).clipboardData || new DataTransfer; c--;) b.items.add(a[c])
        return b.files
    }

    const maskPathHandler = () => {
        const blob = svgToBlob(svgMask(_.get(maskPathRef, 'current.value', '')));
        var maskFile = new File([blob], `${frameName}.svg`, { type: 'image/svg+xml' });
        const files = createFileList(maskFile);
        fileInputRef.current.files = files;
        setTimeout(() => { fileChange({ target: { files: files } }) });
    }

    const getFileDetails = file => {
        const mimeType = (file.type || '').toLowerCase();
        const extension = (file.name.split('.').pop() || '').toLowerCase();
        const isSvg = mimeType.includes('svg') || extension === 'svg';
        const isVideo = mimeType.startsWith('video/') || ['mp4', 'mov'].includes(extension);
        const isImage = mimeType.startsWith('image/') || ['jpg', 'jpeg', 'png', 'gif', 'svg'].includes(extension);

        if (!isImage && !isVideo) return null;

        return {
            file,
            name: file.name,
            fileType: isVideo ? 'video' : 'image',
            imageType: isSvg ? 'svg+xml' : (mimeType.split('/')[1] || extension),
            type: isSvg ? 'Vector' : (isVideo ? 'Video' : 'Image'),
            preview: URL.createObjectURL(file),
        };
    };

    const fileChange = e => {
        const files = Array.from(e.target.files || []);
        setFileError('');
        setDisplayName('');

        if (!files.length) {
            setSelectedFile('');
            return;
        }

        const selectedFiles = files.map(getFileDetails);
        if (selectedFiles.some(file => !file)) {
            selectedFiles.filter(Boolean).forEach(file => URL.revokeObjectURL(file.preview));
            setSelectedFile('');
            setFileError('Unsupported or invalid file. Please select a PNG, JPG, GIF, SVG, MP4 or MOV file.');
            e.target.value = '';
            return;
        }

        setSelectedFile(selectedFiles.length === 1 ? selectedFiles[0] : selectedFiles);
    }

    const svgTypeHandler = e => {
        setSelectedFile({ ...selectedFile, type: e.currentTarget.value })
    }

    const loadPreview = () => {
        setFileError('');
        // if (event.target.tagName === 'VIDEO') {
        //   document.getElementById('width').value = event.target.videoWidth;
        //   document.getElementById('height').value = event.target.videoHeight;
        //   document.getElementById('duration').value = event.target.duration;
        // } else {
        //   document.getElementById('width').value = event.target.width;
        //   document.getElementById('height').value = event.target.height;
        // }
    }

    const frameNameHandler = (e) => {
        const name = e.target.value;
        if (nameTimeout) {
            clearTimeout(nameTimeout);
        }
        nameTimeout = setTimeout(() => { setFrameName(name) }, 700);
    }

    const tags = (
        <Row>
            <Col>
                <span>Tags (En):</span>
                <textarea id="tags" name="tags" />
            </Col>
            <Col>
                <span>Tags (Fa):</span>
                <textarea id="tagsFa" ref={tagsFaRef} name="tagsFa" />
            </Col>
        </Row>);

    const userGroup = (
        <Col style={lite ? { display: 'none' } : undefined}>
            <span>Group:</span>
            <select id="group" name="group" defaultValue={lite ? group : ''}>
                <option value="">All Groups</option>
                <option value="vibino">vibino</option>
                <option value="bdok">bdok</option>
            </select>
        </Col>
    )

    const resourceValue = (
        <Col style={lite ? { display: 'none' } : undefined}>
            <span>Value:</span>
            <select id="price" name="price"  >
                <option value="0">Free</option>
                <option value="1">Premium</option>
            </select>
        </Col>
    )

    const frameDim = (
        <>
            <Col>
                <span>Width:</span>
                <input ref={frameWidthRef} id="frameWidth" name="frameWidth" type="number" required onChange={maskPathHandler} />
            </Col>
            <Col>
                <span>Height:</span>
                <input ref={frameHeightRef} id="frameHeight" name="frameHeight" type="number" required onChange={maskPathHandler} />
            </Col>
        </>
    )

    const imageType = (
        <>
            {(_.get(selectedFile, '[0]fileType', '') === 'image' || _.get(selectedFile, 'fileType', '') === 'image') && !_.get(selectedFile, 'imageType', '').includes('svg') &&
                <Col style={lite ? { display: 'none' } : undefined}>
                    <span>Type:</span>
                    <select id="imageType" name="imageType" onChange={(e) => setResourceFileType(e.target.value)}>
                        <option value="Image">Photo</option>
                        <option value="Background">Background</option>
                        <option value="Vector">Sticker</option>
                    </select>
                </Col>
            }
        </>
    )

    const resourceStatus = (
        <Col style={lite ? { display: 'none' } : undefined}>
            <span>Status:</span>
            <select id="invisible" name="invisible" defaultValue={lite ? 'true' : 'false'}>
                <option value={false}>Published</option>
                <option value={true}>Unpublished</option>
            </select>
        </Col>
    )

    const maskPath = (
        <Row>
            <Col>
                <span>Mask Path:</span><span style={{ fontStyle: 'italic', marginTop: '-10px', fontSize: '92%' }}>(Please insert single svg basic shape element like 'circle', 'path', 'polygon' and 'rect')</span>
                <textarea required ref={maskPathRef} onChange={maskPathHandler} style={{ minHeight: '4rem' }} />
            </Col>
        </Row>
    )

    const maintainRatio = (
        <>
            {_.get(selectedFile, 'imageType', '').includes('svg') &&
                <Col>
                    <span>Maintain ratio:</span>
                    <select id="vectorType" name="vectorType" onChange={svgTypeHandler} >
                        <option value="Vector">Yes</option>
                        <option value="Shape">No</option>
                    </select>
                </Col>
            }
        </>
    )

    const resourceName = (
        <Col className="resource-name-field">
            <label htmlFor={resourceType === 'frame' ? 'frameName' : (Array.isArray(selectedFile) ? 'batchName' : 'name')}>Name:</label>
            {resourceType === 'frame' && <input required onChange={frameNameHandler} id="frameName" name="frameName" />}
            {Array.isArray(selectedFile) ? <>
                <input id="batchName" name="batchName" value={batchName} maxLength={120}
                    placeholder="Optional batch name" disabled={uploading}
                    aria-describedby="batch-name-help" onChange={event => setBatchName(event.target.value)} />
                <small id="batch-name-help">A number is added automatically, e.g. Summer 1.jpg, Summer 2.jpg. Leave blank to keep the original names.</small>
            </> : resourceType !== 'frame' && <>
                <input id="name" name="displayName" value={displayName} maxLength={120}
                    placeholder={_.get(selectedFile, 'name', 'Optional name')} disabled={uploading}
                    aria-describedby="resource-name-help" onChange={event => setDisplayName(event.target.value)} />
                <small id="resource-name-help">Choose a name or leave blank to keep the original filename. The file extension is kept automatically.</small>
            </>}
        </Col>
    )

    const vectorEditable = (
        <>
            {_.get(selectedFile, 'imageType', '').includes('svg') &&
                <Col>
                    <span>Editable:</span>
                    <select id="editable" name="editable"  >
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>
                </Col>
            }
        </>
    )

    return (
        <>
            <form id="uploadForm" ref={uploadFormRef} className={sendUpdate !== 0 && loading === 'loading' ? 'blur' : ""} >{/* onSubmit={uploadFormHandle} > */}
                <Row>
                    <Col>
                        <Row>
                            <Col lg="3">
                                <span>Resource Type:</span>
                                <select id="resourceType" name="resourceType" onChange={resourceTypeChangeHandler} >
                                    <option value="" hidden>---</option>
                                    {resourceTypes.map(option =>
                                        <option value={option.type} key={option.type}>{`${option.name}`}</option>
                                    )}
                                </select>
                            </Col>
                            <input
                                ref={fileInputRef}
                                type="file"
                                name="files"
                                accept="image/jpeg,image/png,image/svg+xml,video/mp4,video/quicktime,image/gif"
                                onChange={fileChange}
                                hidden
                                multiple
                            />
                            {tempId && <input hidden name="tempId" value={tempId} readOnly />}
                            {resourceType === 'file' &&
                                <Col>
                                    <Button
                                        type="button"
                                        style={{ position: 'absolute', bottom: 0, fontSize: '100%', minWidth: '150px' }}
                                        className="vButton colorPrimary "
                                        // content={t('uploadPictureVideo')}
                                        onClick={() => fileInputRef.current.click()}
                                    >{!selectedFile.name ? 'Add File...' : 'Change File...'}</Button>
                                </Col>
                            }
                        </Row>
                        {fileError && <Row><Col><span className="alertDanger">{fileError}</span></Col></Row>}
                        {!resourceType &&
                            (<Row>
                                <Col>
                                    <h5>Please choose resource type.</h5>
                                </Col>
                            </Row>)
                        }
                        {(resourceType === 'frame' || (resourceType === 'file' && selectedFile.name)) &&
                            (<Row>
                                {_.get(selectedFile, 'fileType') === 'video' ?
                                    <Col lg="4" className="resourcePreview"><video onLoadedData={loadPreview} onError={() => setFileError('The selected video could not be previewed.')} src={selectedFile.preview} className="editTemplatePreview" controls /></Col>
                                    :
                                    <Col lg="4" className="resourcePreview"><img alt={selectedFile.name || 'Resource preview'} style={resourceType === 'frame' ? { boxShadow: '0px 0px 12px #ABABAB' } : {}} onLoad={loadPreview} onError={() => setFileError('The selected image could not be previewed.')} src={selectedFile.preview} className="editTemplatePreview" /></Col>
                                }
                                <Col>
                                    <Row>
                                        {resourceName}
                                        {resourceType !== 'frame' && imageType}
                                        {userGroup}
                                        {resourceValue}
                                        {resourceStatus}
                                    </Row>
                                    <Row>
                                        {resourceType === 'frame' && frameDim}
                                        {resourceType !== 'frame' && vectorEditable}
                                        {resourceType !== 'frame' && maintainRatio}
                                    </Row>
                                    {resourceType === 'frame' && maskPath}
                                    {!lite && tags}
                                </Col>
                            </Row>
                            )
                        }
                        {(resourceType === 'file' && Array.isArray(selectedFile)) &&
                            (<>
                                <Row className="multiResourceHolder">
                                    {selectedFile.map((file, index) => {
                                        if (_.get(file, 'fileType') === 'video') {
                                            return <span key={file.name} id={`preview_${index}`} className="multiResourcePreview"><video onLoadedData={loadPreview} onError={() => setFileError('One of the selected videos could not be previewed.')} src={file.preview} className="editTemplatePreview" controls /></span>
                                        } else {
                                            return <span key={file.name} id={`preview_${index}`} className="multiResourcePreview"><div className="loaderHolder"><div className="loader"></div></div><img alt={file.name} style={resourceType === 'frame' ? { boxShadow: '0px 0px 12px #ABABAB' } : {}} onLoad={loadPreview} onError={() => setFileError('One of the selected images could not be previewed.')} src={file.preview} className="editTemplatePreview" /></span>
                                        }

                                        // return (<span className="resourcePreview"><img onLoad={loadPreview} src={file.preview} className="editTemplatePreview" /></span>)
                                    }
                                    )}
                                </Row>
                                <Row>
                                    <Col>
                                        <Row>
                                            {resourceName}
                                            {resourceType !== 'frame' && imageType}
                                            {userGroup}
                                            {resourceValue}
                                            {resourceStatus}
                                        </Row>
                                        <Row>
                                            {resourceType === 'frame' && frameDim}
                                            {resourceType !== 'frame' && vectorEditable}
                                            {resourceType !== 'frame' && maintainRatio}
                                        </Row>
                                        {resourceType === 'frame' && maskPath}
                                        {!lite && tags}
                                    </Col>
                                </Row>
                            </>
                            )
                        }
                    </Col>
                </Row>

            </form>
            {Array.isArray(selectedFile) ?
                <Button ref={uploadBtnRef} style={{ opacity: '0' }} type="button" variant="success" onClick={() => uploadFormHandleMulti(0)}><i className="material-icons"></i> Upload Queue</Button>
                :
                <Button ref={uploadBtnRef} style={{ opacity: '0' }} type="button" variant="success" onClick={uploadFormHandle} disabled={!_.has(selectedFile, 'name')}><i className="material-icons"></i> Upload</Button>
            }
            {createComplete === 2 && (
                <div className="vModal">
                    <div className="vModalContent">
                        <div className="vModalHeader">Upload completed successfully</div>
                        <div className="vModalBody">The resource was uploaded successfully. Please choose an action to continue.</div>
                        <div className="vModalFooter">
                            <Button theme="success" onClick={() => history.push(`/templates-list`)}><i className="material-icons"></i> Start Design</Button>
                            {params.templateId &&
                                <Button className="" theme="primary" onClick={() => {history.push(`/template/${params.templateId}/edit`);window.location.reload();}}><i className="material-icons"></i> Upload Resources</Button>
                            }
                            <Button className="" theme="primary" onClick={() => history.go(0)}><i className="material-icons"></i> Close & New</Button>
                            <Button className="" theme="danger" onClick={() => history.push(params.templateId ? '/templates-list' : '/resources-list')}><i className="material-icons"></i> Close</Button>
                        </div>
                    </div>
                </div>
            )}
            <Modal
                size="sm"
                show={uploading}
                // onHide={() => setSmShow(false)}
                aria-labelledby="example-modal-sizes-title-sm"
                // centered
                backdrop="static"
                keyboard={false}
            >
                <Modal.Body>
                    Uploading...
                    <ProgressBar animated now={!Array.isArray(selectedFile) ? uploadProgress : 100 / uploadingTotal * uploadingIndex} />
                </Modal.Body>
            </Modal>
        </>

    );
}

export default AddResource;
